var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ms-device"},[(_vm.clientId === 0)?_c('span',[_vm._v("综合")]):(_vm.clientId === 1)?_c('span',[_c('icon',{attrs:{"name":"desktop"}})],1):(_vm.clientId === 2)?_c('span',[_c('icon',{attrs:{"name":"mobile"}})],1):(_vm.clientId === 3)?_c('span',[_vm._v("APP")]):_c('span',{staticClass:"ms-gray"},[_vm._v("未知")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130a4a5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Device.vue
// module id = SLOa
// module chunks = 1